import React from 'react';
import Converter from './components/Converter';

function App() {
  return (
    <div className="App">
      <Converter />
    </div>
  );
}

export default App;